import {
  Box,
  Flex,
  GridItem,
  SimpleGrid,
  Skeleton,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react';
import { rem } from 'polished';

type Props = {
  label?: string;
  columns?: Partial<Record<string, number>>;
};

export const CollectionsEmpty = ({
  label,
  columns = { base: 1, md: 2, lg: 3, '2xl': 4 },
}: Props) => {
  const items = useBreakpointValue(columns, 'md');

  return (
    <Box w="full">
      {label && (
        <Text textAlign="center" fontSize="md" color="gray.5" mb="space.24">
          {label}
        </Text>
      )}
      <SimpleGrid
        columns={columns}
        spacing="space.24"
        pos="relative"
        _before={{
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          background: 'linear-gradient(180deg, #13131300 0, #131313 140%)',
          zIndex: 1,
        }}
      >
        {[...Array(items).keys()].map(key => (
          <GridItem key={key} w="100%">
            <Flex direction={{ base: 'row', md: 'column' }}>
              <Skeleton
                speed={0}
                height={{ base: rem(96), md: rem(300) }}
                width={{ base: rem(96), md: '100%' }}
                borderRadius="radius.8"
                mb={{ md: 'space.16' }}
                endColor="gray.1"
                opacity={1}
                mr={{ base: 'space.16', md: 0 }}
              />
              <Flex direction="column" mt={{ base: 'space.16', md: 0 }}>
                <Skeleton
                  speed={0}
                  height={rem(16)}
                  width={{ base: rem(135), md: '1 / 3' }}
                  borderRadius={rem(100)}
                  mb={{ base: 'space.8', md: 'space.16' }}
                  endColor="gray.1"
                  opacity={1}
                />
                <Skeleton
                  speed={0}
                  height={rem(8)}
                  width={{ base: rem(95), md: '1 / 5' }}
                  borderRadius={rem(100)}
                  mb={{ md: 'space.16' }}
                  endColor="gray.1"
                  opacity={1}
                />
              </Flex>
            </Flex>
          </GridItem>
        ))}
      </SimpleGrid>
    </Box>
  );
};
